import request from '@/utils/request';
import requestSign from '@/utils/requestSign'

// 获取事故详情
export function getAccident(accidentId) {
  return request({
    url: '/accident',
    method: 'get',
    params: { accidentId }
  });
}

// 新建事故
export function createAccident(data) {
  return request({
    url: '/accident/create',
    method: 'post',
    data
  });
}

// 注销事故
export function cancellationAccident(accidentId) {
  return request({
    url: '/accident/cancellation',
    method: 'post',
    params: { accidentId }
  });
}

// 编辑事故
export function saveAccident(data, type) {
  return request({
    url: '/accident/save',
    method: 'post',
    data,
    params: { type } // 0自动暂存 1暂存 2提交
  });
}

// 获取事故操作记录
export function getAccidentLog(accidentId) {
  return request({
    url: '/accident/log',
    method: 'get',
    params: { accidentId }
  });
}

// ? 获取定责信息
export function getSimulate(accidentId) {
  return request({
    url: '/accident/simulate',
    method: 'get',
    params: { accidentId }
  });
}

// ? 获取责任初步意见书
export function getSubmission(accidentId) {
  return request({
    url: '/accident/letterOfOesponsibility',
    method: 'get',
    params: { accidentId }
  });
}

// ? 获取责任人列表
export function getResponsibleList(accidentId) {
  return request({
    url: '/accident/findPartyByAccidentId',
    method: 'get',
    params: { accidentId }
  });
}

// ? 提交责任初步意见书
export function submitSubmission(data) {
  return request({
    url: '/accident/letterOfOesponsibility',
    method: 'post',
    data
  });
}

// 定责
export function liability(data, params) {
  return request({
    url: '/accident/liability',
    method: 'post',
    data,
    params
  });
}

export function getLiabilityStatement(accidentId) {
  return request({
    url: '/accident/liabilityStatement',
    method: 'get',
    params: { accidentId }
  });
}

// 获取理赔信息
export function getClaim(accidentId, partyId) {
  return request({
    url: '/accident/claim',
    method: 'get',
    params: { accidentId, partyId }
  });
}

// 理赔
export function claim(data) {
  return request({
    url: '/accident/claim',
    method: 'post',
    data
  });
}

// 获取操作记录
export function getLog(params) {
  return request({
    url: '/accident/log',
    method: 'get',
    params
  });
}

// 根据身份证号查询信息
export function getInfoByIdCardNum(idCard) {
  return request({
    url: '/accident/interface/idCard/info',
    method: 'get',
    params: { idCard }
  });
}

// 通过身份证号获取驾驶证
export function getInfoByDrivingLicenseNum(idCard) {
  return request({
    url: '/accident/interface/idCard/license',
    method: 'get',
    params: { idCard }
  });
}

// 根据车牌号获取行驶证
export function getInfoByCarLicenseNum(vehicleNumber) {
  return request({
    url: '/accident/interface/idCard/vehicle',
    method: 'get',
    params: { vehicleNumber }
  });
}

// 通过人脸照片获取身份信息
export function getInfoByFacePhoto(photo) {
  return request({
    url: '/accident/interface/photo/face',
    method: 'post',
    params: photo
  });
}

// id查询医院伤者详情
export function getWoundedById(params) {
  return request({
    url: '/accidentWounded/getWoundedById',
    method: 'get',
    params
  });
}
// id查询拖修车伤者详情
export function getCarRescueInfoById(params) {
  return request({
    url: '/partyMaintenance/getCarRescueInfoById',
    method: 'get',
    params
  });
}
// 身份证查询当事人今年已发生事故
export function driverNum(idCardNum, carLicenceNum) {
  return request({
    url: '/accident/driverNum',
    method: 'get',
    params: { idCardNum, carLicenceNum }
  });
}
// 保险截图
export function saveInsuranceAccidentPhotoList(urls, accidentId) {
  return request({
    url: '/accident/saveInsuranceAccidentPhoto',
    method: 'post',
    params: { urls, accidentId }
  });
}
// 保协接口
export function queryInsuranceInfo(licensePlateNo, licensePlateType, vin) {
  return request({
    url: '/queryInsuranceInfo',
    method: 'post',
    params: { licensePlateNo, licensePlateType, vin }
  });
}

// 保险一键报警
export function renBao(accidentId, vin, partyName, partyPhone, partyCarLicenseNum, insuredName, accidentTime, objectName, accidentType) {
  return request({
    url: '/renBao',
    method: 'post',
    params: { accidentId, vin, partyName, partyPhone, partyCarLicenseNum, insuredName, accidentTime, objectName, accidentType }
  });
}

// 平安一键报警
export function pingAn(data) {
  return request({
    url: '/pingAn',
    method: 'post',
    data
  });
}

// 签名的时候获取定责书
export function SignName(accidentId, telPhone) {
  return request({
    url: '/accidentparty/getSignByAccidentIdAndTelPhone',
    method: 'get',
    params: { accidentId, telPhone },
  });
}

//直赔通知书
export function SignZhipei(accidentId, telPhone,type) {
  return request({
    url: '/accidentWounded/getSignByAccidentIdAndTelPhone',
    method: 'get',
    params: { accidentId, telPhone,type },
  });
}

// 签名完成发送签字的定责书和签名
export function SignAble(formData) {
  return requestSign({
    url: '/accidentparty/saveSignByAccidentIdAndDriverId',
    method: 'put',
    params: formData,
  });
}

// 计算5g视频时长
export function getVideoTimeBy5G(params) {
  return request({
    url: '/video/trtc/getVideoTimeBy5G',
    method: 'get',
    params
  });
}
// 5g视频地址保存
export function videoUrlAndTimeBy5GId(data) {
  return request({
    url: '/video/trtc/videoUrlAndTimeBy5GId',
    method: 'post',
    params: data
  });
}
// 5g视频邀请他人
export function inviteOther(data) {
  return request({
    url: '/phone/inviteOther',
    method: 'post',
    data
  });
}

// 5g视频销毁房间
export function closeRoom(params) {
  return request({
    url: '/phone/closeRoom',
    method: 'get',
    params: {params}
  });
}
// 查询用户
export function allUserByRoleIds(params) {
  return request({
    url: '/system/user/allUserByRoleIds',
    method: 'get',
    params: params
  });
}

// 保险报案标准接口
export function insuranceReport(data, params) {
  return request({
    url: '/insuranceReport',
    method: 'post',
    data,
    params
  });
}

export function callbackUrl(data) {
  return request({
    url: '/video/trtc/callback',
    method: 'post',
    data
  });
}
